import { createRequestModel, createRequestFetcher } from 'src/dal/modules';
import { apiEndpoints } from 'src/dal/config/apiEndpoints';
import { RequestMethod } from 'src/dal/config/requestMethod';

import type { TListResponsePayload } from 'src/dal/typing';
import type { TLegal } from './typing';

const getLegals = createRequestModel({
  method: RequestMethod.GET,
  path: apiEndpoints.getLegals,
});

export const getLegalsFetcher = createRequestFetcher<TListResponsePayload<TLegal>, void>(getLegals);
